/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */

/**
 * * `Z1` - Ucraina și Belarus
 * * `Z3` - Toate țările sistemului carte verde
 */
export enum ZoneEnum {
  Z1 = 'Z1',
  Z3 = 'Z3',
}
